import { createStore, applyMiddleware, compose } from 'redux';

import { persistWidgetBlockStateMiddleware } from './persistWidgetBlockStateMiddleware';
import { constructStore } from './reducers';

export default (components, otherReducers, otherMiddleware = [], initialState) => {
    const reduxDevToolFunc = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (arg) => arg;

    const finalCreateStore = compose(applyMiddleware(...otherMiddleware, persistWidgetBlockStateMiddleware), reduxDevToolFunc)(createStore);

    const store = finalCreateStore(constructStore(components, otherReducers), initialState);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('./WidgetBlockReducer', () => {
            import('./reducers').then((reducers) => {
                const { constructStore } = reducers;

                store.replaceReducer(constructStore(components, otherReducers));
            });
        });
    }

    return store;
};
